type AriaParamType =
  | Record<string, string | null | undefined>
  | string
  | undefined;

export function combineAriaBy(type: string, params: Array<AriaParamType>) {
  const p = params.map((item) => {
    let out: AriaParamType | null = item;

    if (
      typeof item === 'object' &&
      typeof item[type] !== 'undefined' &&
      params.includes(item[type] as string)
    ) {
      return null;
    }

    if (typeof item === 'object' && typeof item[type] !== 'undefined') {
      out = item[type] as string;
    }

    if (typeof out !== 'string') {
      return null;
    }

    return out;
  });

  const result = p.filter(Boolean).join(' ');

  if (result === '') {
    return undefined;
  }

  return result;
}

export function combineDescribedBy(...params: Array<AriaParamType>) {
  return combineAriaBy('aria-describedby', params);
}

export function mergeRefs<T>(
  ...refs:
    | Array<React.MutableRefObject<T> | React.LegacyRef<T>>
    | Array<Array<React.MutableRefObject<T> | React.LegacyRef<T>>>
): React.RefCallback<T> {
  return (value) => {
    refs.flat().forEach((ref) => {
      if (typeof ref === 'function') {
        ref(value);
      } else if (ref !== null) {
        (ref as React.MutableRefObject<T | null>).current = value;
      }
    });
  };
}
